import React, {memo, useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {toast} from "react-toastify";
import Api from "../../../utils/api";
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import {Loading} from './../../../components/index'
import ReCaptcha from "../../../components/reCaptcha";

const PasswordReset = memo((props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [step, setStep] = useState(0);
    const [username, setUserName] = useState('');
    const [verifyCode, setVerifyCode] = useState('');
    const [password, setPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [token, setToken] = useState('');
    // captcha prefix
    const [captcha, setCaptcha] = useState(null);
    const [captchaRegenerate, setCaptchaRegenerate] = useState(true);

    useEffect(() => {
        if (captcha) {
            setCaptchaRegenerate(false);
            setLoading(false);
        }
    }, [captcha]);



    const handleSubmit = (event) => {

        event.preventDefault();

        switch (step) {
            case 0:

                setLoading(true);

                new Api().post('/auth/sendVerifyCode', { username: username, captcha: captcha }).then((response) => {
                    if (typeof response != "undefined") {
                        if (response.status) {
                            setToken(response.token);
                            setStep(parseInt(step) + 1);
                            toast.success(response.msg);
                        } else {
                            toast.error(response.msg)
                        }
                    }
                    setCaptchaRegenerate(true);
                    setLoading(false);
                })
                break;
            case 1:
                setLoading(true);
                new Api().post('/auth/checkVerifyCode', {'token': token, 'verify_code': verifyCode, captcha: captcha}).then((response) => {
                    if (typeof response != "undefined") {
                        if (response.status) {
                            setToken(response.token);
                            setStep(parseInt(step) + 1);
                            toast.success(response.msg);
                        } else {
                            toast.error(response.msg)
                        }
                    }
                    setCaptchaRegenerate(true);
                    setLoading(false);
                })
                break;
            case 2:
                if (password !== confirm_password) {
                    toast.error('پسورد یکسان نیست');
                    return;
                }
                setLoading(true);
                new Api().post('/auth/passwordRecovery', {token: token, 'password': password, captcha: captcha}).then((response) => {
                    if (typeof response != "undefined") {
                        if (response.status) {
                            toast.success(response.msg);
                            setTimeout(() => {
                                navigate('/');
                            }, 1000);
                        } else {
                            toast.error(response.msg)
                        }
                    }
                    setCaptchaRegenerate(true);
                    setLoading(false);
                })
                break;
            case 3:
                navigate('/');
                break;
        }


    }

    const stepper = () => {
        switch (step) {
            case 0:
                return(
                    <form noValidate={true} onSubmit={handleSubmit}>
                        <TextField
                            autoComplete={'off'}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="موبایل,ایمیل یا نام کاربری"
                            name="username"
                            autoFocus
                            onChange={(event) => setUserName(event.target.value)}
                        />
                        <Box mt={2} mb={2}>
                            <Button
                                disabled={loading}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                            >
                                ارسال کد فعال سازی
                            </Button>
                        </Box>
                        <Box mt={2} mb={2}>
                            <Button
                                onClick={() => navigate('/')}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                            >
                                بازگشت به صفحه ورود
                            </Button>
                        </Box>
                        <Grid container>
                        </Grid>
                    </form>
                );
            case 1:
                return (
                    <form noValidate={true} onSubmit={handleSubmit}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id={'verify_code'}
                            label="کد فعالسازی"
                            autoFocus
                            autoComplete="off"
                            name="verify_code"
                            onChange={(event) => setVerifyCode(event.target.value)}
                        />
                        <Box mt={2} mb={2}>
                            <Button
                                disabled={loading}
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                            >
                                تایید کد فعالسازی
                            </Button>
                        </Box>
                    </form>
                );
            case 2:
                return (
                    <form noValidate={true} onSubmit={handleSubmit}>
                        <TextField
                            autoComplete={'off'}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="رمز عبور جدید"
                            name="password"
                            type="password"
                            autoFocus
                            onChange={(event) => setPassword(event.target.value)}
                        />
                        <TextField
                            autoComplete={'off'}
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="تکرار رمز عبور"
                            name="confirm_password"
                            type="password"
                            onChange={(event) => setConfirmPassword(event.target.value)}
                        />
                        <Box mt={2} mb={2}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                            >
                                تغییر رمز عبور
                            </Button>
                        </Box>
                        <Grid container>
                        </Grid>
                    </form>
                );

        }
    }


    return (
        <Container maxWidth="xs">
            <Box mt={15} className='display-flex display-flex-direction-column display-flex-justify-content-center'>
                <Avatar style={{ backgroundColor: 'var(--danger-color)'}}>
                    <PermPhoneMsgIcon />
                </Avatar>
                <Typography variant="h5">
                    بازیابی رمز عبور
                </Typography>
            </Box>
            <Box mt={3}>
                { stepper() }
            </Box>
            <Box mt={2} component={"div"} style={{ position: 'relative'}}>
                {loading && <Loading />}
            </Box>
            <Box mt={10}>
                <Typography variant="body2" color="textSecondary" align="center">
                    {'Copyright © '}
                    <span style={{ fontFamily: 'tahoma'}}> {new Date().getFullYear()}</span>
                </Typography>
            </Box>
            <ReCaptcha regenerate={captchaRegenerate}  onComplete={(token) => setCaptcha(token)} />
        </Container>
    );

})


const mapStateToProps = state => ({
    authReducer: state.authReducer
});

export default connect(mapStateToProps)(PasswordReset)
